import {Tokens, User} from 'patja-api';
import {Observable} from 'rxjs';
import {Signal} from '@angular/core';

export abstract class AbstractAuthService {
  abstract getChallenge(): string | null;

  abstract setUser(user: User): void;

  abstract storeToken(token: Tokens): void;

  abstract getUser(): Observable<Signal<User | null>>;
}
